import { Node } from "@tiptap/core";
import { mergeAttributes, VueNodeViewRenderer } from "@tiptap/vue-3";
import AiTextResults from "./AiTextResults.vue";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    aiTextResults: {
      /** 添加结果到编辑区 */
      addAiTextResults: (text: string) => ReturnType;
    };
  }
}

export default Node.create({
  name: "aiTextResults",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  addAttributes() {
    return { text: { default: "" } };
  },
  parseHTML() {
    return [{ tag: "ai-text-results" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["ai-text-results", mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return VueNodeViewRenderer(AiTextResults);
  },
  addCommands() {
    return {
      addAiTextResults:
        (text: string) =>
        ({ chain }) => {
          return chain()
            .setMeta("addToHistory", false)
            .insertContent({
              type: "aiTextResults",
              attrs: { text },
            })
            .run();
        },
    };
  },
});
